import React from 'react';
import { Button } from '../ui/Button';
import { trackAddToCart } from '../../utils/metaPixel';
interface StickyBarProps {
  isVisible: boolean;
}
export function StickyBar({
  isVisible
}: StickyBarProps) {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className={`
        fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-stone-200 shadow-[0_-10px_40px_rgba(0,0,0,0.05)]
        transform transition-transform duration-500 ease-in-out
        ${isVisible ? 'translate-y-0' : 'translate-y-full'}
      `} data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between" data-id="element-200">
        <div className="hidden md:block" data-id="element-201">
          <p className="font-serif text-lg font-medium text-stone-900" data-id="element-202">
            48-Hour Gut Reset Planner
          </p>
          <p className="text-sm text-stone-500" data-id="element-203">
            Look leaner and feel lighter by Friday.
          </p>
        </div>

        <div className="flex items-center justify-between w-full md:w-auto space-x-6" data-id="element-204">
          <div className="text-right" data-id="element-205">
            <span className="block text-xs text-stone-500 uppercase tracking-wider font-semibold" data-id="element-206">
              Total
            </span>
            <span className="block text-xl font-serif font-medium text-stone-900" data-id="element-207">
              $19
            </span>
          </div>
          <Button href="https://thedailyedit.it.com/cart/47830899851456:1" onClick={trackAddToCart} className="whitespace-nowrap px-8" data-id="element-208">
            GET IT NOW
          </Button>
        </div>
      </div>
    </div>;
}